export default {
  BASE_URL: "https://staging.finitetime.io/",
};
